import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Header from "@/components/Header";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import RulesPage from "@/pages/RulesPage";
import TeamsPage from "@/pages/TeamsPage";
import BracketPage from "@/pages/BracketPage";
import AdminInboxPage from "@/pages/AdminInboxPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminEditPage from "@/pages/AdminEditPage";
import AdminEventsPage from "@/pages/AdminEventsPage";
import AdminBadgesPage from "@/pages/AdminBadgesPage";
import ResultsPage from "@/pages/ResultsPage";
import ScreenshotsPage from "@/pages/ScreenshotsPage";
import TournamentPage from "@/pages/TournamentPage";
import ClansPage from "@/pages/ClansPage";
import PlayersPage from "@/pages/PlayersPage";
import PlayerMessagesPage from "@/pages/PlayerMessagesPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-[#050505]">
        <BrowserRouter>
          <Header />
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/rules" element={<RulesPage />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/bracket" element={<BracketPage />} />
              <Route path="/clans" element={<ClansPage />} />
              <Route path="/players" element={<PlayersPage />} />
              <Route path="/messages" element={<PlayerMessagesPage />} />
              <Route path="/admin/inbox" element={<AdminInboxPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/edit" element={<AdminEditPage />} />
              <Route path="/admin/events" element={<AdminEventsPage />} />
              <Route path="/admin/badges" element={<AdminBadgesPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/screenshots" element={<ScreenshotsPage />} />
              <Route path="/tournament" element={<TournamentPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </div>
    </AuthProvider>
  );
}

export default App;
